import { yupResolver } from '@hookform/resolvers/yup';
import { Dialog } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { IDevice } from 'v3/data/store/device/types';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { InputFormController } from 'v3/shared/components/Inputs/InputFormController';
import { IChangePurchaseInfoProps } from 'v3/shared/components/Modal/ChangePurchaseInfoModal/types';
import {
  AlignButtons,
  CloseIconStyled,
  Gap,
  MainContainer,
  SecondaryContainer,
  TitleContainer,
  paperStyles,
} from 'v3/shared/components/Modal/GenericNameModal/styles';
import { deviceFormSchema } from 'v3/shared/schemas/device';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';

export const ChangePurchaseInfoModal: React.FC<IChangePurchaseInfoProps> = ({
  title,
  active,
  onClose,
  currentDevice,
  onSave,
  removeEanFeatureEnabled,
}) => {
  const formSchema = useMemo(() => deviceFormSchema(!removeEanFeatureEnabled), [removeEanFeatureEnabled]);

  const {
    control,
    getValues,
    reset,
    formState: { isValid },
  } = useForm<IDevice>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      imei: currentDevice?.imei ?? '',
      invoiceNumber: currentDevice?.invoiceNumber ?? '',
      invoiceSeries: currentDevice?.invoiceSeries ?? '',
      ean: currentDevice?.ean ?? '',
    },
    resolver: yupResolver(formSchema) as any,
  });
  useEffect(() => {
    reset({
      imei: currentDevice?.imei ?? '',
      invoiceNumber: currentDevice?.invoiceNumber ?? '',
      invoiceSeries: currentDevice?.invoiceSeries ?? '',
      ean: currentDevice?.ean ?? '',
    });
  }, [
    active,
    currentDevice?.imei,
    currentDevice?.invoiceNumber,
    currentDevice?.invoiceSeries,
    currentDevice?.ean,
    reset,
  ]);

  const handleSave = () => {
    const { imei, invoiceNumber, invoiceSeries, ean } = getValues();
    onSave({
      imei: imei.trim(),
      invoiceNumber: invoiceNumber.trim(),
      invoiceSeries: invoiceSeries.trim(),
      ean: ean?.trim(),
    });
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      open={active}
      aria-labelledby="customized-dialog-title"
      aria-describedby="customized-dialog-description"
      PaperProps={paperStyles}
    >
      <MainContainer>
        <TitleContainer>
          <SecondaryContainer>
            <SubtitleLarge>{title}</SubtitleLarge>
          </SecondaryContainer>
          <CloseIconStyled onClick={onClose} />
        </TitleContainer>
        <Gap>
          <InputFormController
            data-testid="input-invoice-number"
            formControl={control}
            formControlName="invoiceNumber"
            label="Número da nota fiscal"
          />
          <InputFormController
            data-testid="input-invoice-series"
            formControl={control}
            formControlName="invoiceSeries"
            label="Série da nota fiscal"
          />
          <InputFormController data-testid="input-imei" formControl={control} formControlName="imei" label="IMEI" />
          {!removeEanFeatureEnabled && (
            <InputFormController data-testid="input-ean" formControl={control} formControlName="ean" label="EAN" />
          )}

          <AlignButtons>
            <TextButton text="Cancelar" $outline size="small" handleClick={onClose} />
            <FlexButton text="Salvar alterações" size="small" disabled={!isValid} handleClick={handleSave} />
          </AlignButtons>
        </Gap>
      </MainContainer>
    </Dialog>
  );
};
